import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "@material-ui/core";
import { Polygon, Circle } from "react-google-maps";

/* eslint-disable no-undef */
const getDistanceInMeters = (from, to) =>
  google.maps.geometry.spherical.computeDistanceBetween(
    new google.maps.LatLng(from.lat, from.lng),
    new google.maps.LatLng(to.lat, to.lng),
  );
/* eslint-enable no-undef */

class ZoneDrawingManager extends Component {
  state = {
    polygonPath: [],
    circleCenter: null,
    circleRadius: 0,
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.drawingMode !== this.props.drawingMode &&
      this.props.drawingMode === this.props.drawingModes.none
    ) {
      this.reset();
    }
  }

  reset = () => {
    this.setState({
      polygonPath: [],
      circleCenter: null,
      circleRadius: 0,
    });
  };

  handleMapClick = (event) => {
    const { drawingMode, drawingModes } = this.props;

    const point = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    };

    if (drawingMode === drawingModes.polygon) {
      this.setState((state) => ({
        polygonPath: [...state.polygonPath, point],
      }));

      return true;
    }

    if (drawingMode === drawingModes.circle) {
      if (!this.state.circleCenter) {
        this.setState({
          circleCenter: point,
          circleRadius: 50,
        });

        return true;
      }

      this.props.onCircleComplete({
        center: this.state.circleCenter,
        radius: getDistanceInMeters(this.state.circleCenter, point),
      });

      this.reset();

      return true;
    }

    return false;
  };

  handleMouseMove = (event) => {
    const { drawingMode, drawingModes } = this.props;

    if (drawingMode !== drawingModes.circle || !this.state.circleCenter) {
      return;
    }

    const point = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    };

    this.setState({
      circleRadius: getDistanceInMeters(this.state.circleCenter, point),
    });
  };

  handleFinishDrawing = () => {
    const { drawingMode, drawingModes } = this.props;

    if (drawingMode !== drawingModes.polygon) return;
    if (this.state.polygonPath.length < 3) return;

    /* eslint-disable no-undef */
    const polygon = new google.maps.Polygon({
      paths: this.state.polygonPath,
    });
    /* eslint-enable no-undef */

    this.props.onPolygonComplete(polygon);
    this.reset();
  };

  render() {
    const { drawingMode, drawingModes } = this.props;
    const finishButtonStyle = {
      position: "absolute",
      top: 88,
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 10,
    };

    return (
      <>
        {drawingMode === drawingModes.polygon && (
          <Button
            style={finishButtonStyle}
            variant="contained"
            color="primary"
            onClick={this.handleFinishDrawing}
            disabled={this.state.polygonPath.length < 3}
          >
            Zakończ rysowanie
          </Button>
        )}

        {this.state.polygonPath.length > 0 && (
          <Polygon
            path={this.state.polygonPath}
            options={{
              fillColor: "#FFB74D",
              zIndex: 3,
              fillOpacity: 0.3,
              strokeWeight: 2,
              clickable: false,
            }}
          />
        )}

        {this.state.circleCenter && (
          <Circle
            center={this.state.circleCenter}
            radius={this.state.circleRadius}
            options={{
              fillColor: "#FFB74D",
              zIndex: 3,
              fillOpacity: 0.3,
              strokeWeight: 2,
              clickable: false,
            }}
          />
        )}
      </>
    );
  }
}

ZoneDrawingManager.propTypes = {
  drawingMode: PropTypes.string,
  drawingModes: PropTypes.object.isRequired,
  onPolygonComplete: PropTypes.func.isRequired,
  onCircleComplete: PropTypes.func.isRequired,
};

ZoneDrawingManager.defaultProps = {
  drawingMode: null,
};

export default ZoneDrawingManager;
